'use strict';

module.exports = [
  '$window',
  ResponsiveContentDirective];

function ResponsiveContentDirective($window) {
  return {
    restrict: 'E',
    template: '<div ng-include="templateUrl"></div>',
    link: function ResponsiveContentLink($scope, $element, $attrs) {

      $window.addEventListener('resize', onResize);
      changeTemplate();
      $scope.$on('$destroy', cleanup);

      function onResize() {
        changeTemplate();
        $scope.$apply();
      }

      function changeTemplate() {
        var screenWidth = $window.innerWidth;
        if (screenWidth < 900) {
          $scope.templateUrl = $attrs.smallTemplate;
        } else if (screenWidth >= 900) {
          $scope.templateUrl = $attrs.largeTemplate;
        }
      }

      function cleanup() {
        $window.removeEventListener('resize', onResize);
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/js/core-utilities/responsive-components/ResponsiveContentDirective.js